export default "__VITE_ASSET__CsX5zbym__"